import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=78cc2a20"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports